import DeviceTableDto from 'app/admin/device/dto/DeviceTableDto';
import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';
import FileInfoDto from 'app/admin/file/dto/FileInfoDto';
import MeasurementStatus from './MeasurementStatus';

export default class MeasurementTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {DeviceTableDto} */
		this.device = null;
		/** @type {FileInfoDto} */
		this.file = null;
		/** @type {Date} */
		this.created = null;
		/** @type {Date} */
		this.updated = null;
		/** @type {NamedDto} */
		this.project = null;
		/** @type {string} */
		this.status = null;
		/** @type {NamedDto} */
		this.infrastructureElement = null;
		/** @type {string} */
		this.location = null;
	}

	/**
	 * @typedef {Object} _MeasurementTableDtoProps
	 * @property {DeviceTableDto} device
	 * @property {FileInfoDto} file
	 * @property {Date} created
	 * @property {Date} updated
	 * @property {NamedDto} project
	 * @property {string} status
	 * @property {NamedDto} infrastructureElement
	 * @property {string} location
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _MeasurementTableDtoProps} MeasurementTableDtoProps
	 */
	/**
	 *
	 * @param {MeasurementTableDtoProps} props
	 * @returns {MeasurementTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.device = props.device !== null ? new DeviceTableDto().setup(props.device) : null;
		//this.file = props.file !== null ? new FileInfoDto().setup(props.file) : null;
		this.created = props.created != null ? new Date(props.created) : null;
		this.updated = props.updated != null ? new Date(props.updated) : null;
		this.project = props.project !== null ? new NamedDto().setup(props.project) : null;
		//this.status = props.status;
		//this.infrastructureElement = props.infrastructureElement !== null ? new NamedDto().setup(props.infrastructureElement) : null;
		this.location = props.location;
		return this;
	}

	getAsString(key) {
		if (key === 'status') {
			return this.status ? MeasurementStatus[this.status] : '';
		}
		return super.getAsString(key);
	}
}
